export default "__VITE_ASSET__DTVJNjV4__"